import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaceList = _resolveComponent("FaceList")!
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup,
        size: "large"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Merge {name} with person', { name: _ctx.$route.params.name })), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_NcButton, {
            onClick: _ctx.close,
            class: "button",
            variant: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_FaceList, { onSelect: _ctx.clickFace }, null, 8, ["onSelect"]),
            (_ctx.processingTotal > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_NcProgressBar, {
                    value: Math.round((_ctx.processing * 100) / _ctx.processingTotal),
                    error: true
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}